/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface DropdownItem {
  title: string;
  description?: string;
  href: string;
  icon?: React.ReactNode;
}

export interface DropdownMenuSimpleProps {
  items: DropdownItem[];
  className?: string;
}

// ---------------------------------------------------------------------------
// DropdownMenuSimple
// ---------------------------------------------------------------------------

export function DropdownMenuSimple({ items, className }: DropdownMenuSimpleProps) {
  return (
    <div className={cn("min-w-[240px] p-2", className)}>
      {items.map((item) => (
        <Link
          key={item.href}
          to={item.href}
          className="flex items-start gap-3 rounded-lg px-3 py-2.5 transition-colors hover:bg-gray-50"
        >
          {item.icon && (
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-[#1FA9FF]/10 text-[#1FA9FF]">
              {item.icon}
            </span>
          )}
          <div className="flex flex-col">
            <span className="text-sm font-medium text-gray-900">{item.title}</span>
            {item.description && (
              <span className="mt-0.5 text-sm text-gray-500">{item.description}</span>
            )}
          </div>
        </Link>
      ))}
    </div>
  );
}

export default DropdownMenuSimple;
